import { ReactNode } from 'react'
import { customerLogos } from './customers'

export type Quote = {
  cite: string
  quote: string | ReactNode
  logo?: string
  cta?: string
  ctaLabel?: string
}

export const QuoteAscend: Quote = {
  cite: 'Shyam Sivakumar, Head of Data',
  logo: customerLogos.ascend,
  quote: `When you introduce a tool with better performance and visualizations, and a more intuitive user experience, I find you usually see a step change in adoption across the organization, and that's been our experience with Omni.`,
  cta: '/blog/case-study-ascend',
}

export const QuoteAviatrix: Quote = {
  cite: 'Cody Pulliam, Senior Manager of Business Analytics',
  logo: customerLogos.aviatrix,
  quote: `Compared to Tableau and Looker, Omni was by far the best performer in terms of all-around functionality.`,
  cta: '/blog/case-study-aviatrix',
}

export const QuoteAviatrix2: Quote = {
  cite: 'Cody Pulliam, Senior Manager of Business Analytics, Aviatrix',
  logo: customerLogos.aviatrix,
  quote: `Despite having a complex model, a large backlog of content, and more than 100 users, we were able to complete the migration to Omni in just three weeks with the help of Omni’s team.`,
  cta: '/blog/case-study-aviatrix',
}

export const QuoteAviatrix3: Quote = {
  cite: 'Travis Mitchell, Sr Principal Product Operations Manager',
  logo: customerLogos.aviatrix,
  quote: `Wow, AI did something useful for me 🙂`,
}

export const QuoteDatabricks: Quote = {
  cite: 'Andrew Ferguson, VP of Databricks Ventures',
  logo: customerLogos.databricks,
  quote: `At Databricks, we're focused on making data and AI accessible to everyone. A key part of that is bridging the gap between technical data teams and business users. We're excited to invest in and partner with Omni as the first business intelligence company in the Databricks Ventures portfolio. Omni's approach to business intelligence aligns with our vision for the future of data and AI, and we look forward to supporting their continued growth and success.`,
}

export const QuoteTheRounds: Quote = {
  cite: 'Ari Stern, Staff Analytics Engineer',
  logo: customerLogos.theRounds,
  cta: '/blog/case-study-the-rounds',
  quote: `With Omni, our data team now focuses on new projects, while business
  users make faster decisions. This efficiency is crucial for
  sustainable business operations.`,
}

export const QuoteTheRounds2: Quote = {
  cite: 'Griffin Tschurwald, Head of Engineering',
  logo: customerLogos.theRounds,
  cta: '/blog/case-study-the-rounds',
  quote: `We have a lot of people who are Excel power users and they love the
  ability to pivot quickly in Omni.`,
}

export const QuoteSifflet: Quote = {
  cite: 'Martin Zerbib, Head of Product',
  logo: customerLogos.sifflet,
  quote: `Omni balances the best of Looker's code-based modeling layer approach
  with the best of Tableau's self-service workbooks — empowering a wider
  variety of users to explore and consume without falling into the
  pitfall of complexity creep.`,
  cta: '/blog/case-study-sifflet',
}

export const QuoteSifflet2: Quote = {
  cite: 'Martin Zerbib, Head of Product at Sifflet',
  logo: customerLogos.sifflet,
  quote: `The implementation was incredibly straightforward and very fast. We were able to build a dashboard on the very first day.`,
  cta: '/blog/case-study-sifflet',
}

export const QuoteEbh: Quote = {
  cite: 'Mark Valdez, CEO',
  logo: customerLogos.ebh,
  cta: '/blog/case-study-eads-bridge-holdings',
  quote: `Replacing our previous BI tool with Omni gave us another level of
insight and ease that we really need, internally and for our
companies. Now, we're able to extend that impact across our companies
to help them access data without requiring in-house data experts or
tools.`,
}

// export const QuoteRoseRocket = {
//   cite: 'Jade Khiev, Insights Engineering Lead',
//   logo: customerLogos.roseRocket,
//   quote: `Redefining our product and go-to-market strategy has resulted in exceptional growth, but it also meant we needed to maximize the flexibility, performance, and ease of data access. By using Omni and Snowflake, our internal users can self-serve and get faster answers. This frees up our technical resources to focus on delivering the best product and customer experience.`,
//   cta: '/blog/case-study-rose-rocket',
// }

export const QuoteRoseRocket2 = {
  cite: 'Jade Khiev, Insights Engineering Lead',
  logo: customerLogos.roseRocket,
  quote: `It's very intuitive. We've received feedback from many of our co-workers that Omni just feels so much easier than Looker.`,
  cta: '/blog/case-study-rose-rocket',
}
export const QuoteRoseRocket3 = {
  cite: 'Jade Khiev, Insights Engineering Lead',
  logo: customerLogos.roseRocket,
  quote: `Migrating to Omni allowed my team to hand off most of the day-to-day internal analytics needs so we can focus on our platform and building new value for our customers.`,
  cta: '/blog/case-study-rose-rocket',
}

// export const QuoteTrint: Quote = {
//   cite: 'Anya Osen Barnett, Senior Analytics Engineer',
//   logo: customerLogos.trint,
//   quote: `I really love Snowflake’s SQL syntax. It’s just more advanced than other dialects of SQL. When you’re trying to duplicate something, you’d normally have to create another CTE, and that ends up being very bulky. With Snowflake, you can just use the QUALIFY clause instead.`,
//   cta: '/blog/case-study-trint',
// }

export const QuoteTrint2: Quote = {
  cite: 'Anya Osen Barnett, Senior Analytics Engineer',
  logo: customerLogos.trint,
  quote: `We ended up having team members who weren’t previously comfortable using our BI tool ask for access to Omni, and now we have more people actively using BI with Omni than before.`,
  cta: '/blog/case-study-trint',
}

export const QuoteTrint3: Quote = {
  cite: 'Anya Osen Barnett, Senior Analytics Engineer',
  logo: customerLogos.trint,
  quote: `Every time I make a change to the model in dbt, all I need to do is refresh the schema, and the change is reflected in Omni automatically. Before, it was manual. We had a whole section of tickets just reminding us to make the corresponding changes in our previous BI tool.`,
  cta: '/blog/case-study-trint',
}

export const QuoteTrint4: Quote = {
  cite: 'Anya Osen Barnett, Senior Analytics Engineer',
  logo: customerLogos.trint,
  quote: `Omni opens up data exploration to more people on the team. Our previous tool required expertise in SQL or a custom coding language to do calculations, but Omni Calculations use Excel syntax which makes things much easier for people.`,
  cta: '/blog/case-study-trint',
}

export const QuoteSnowflakePartner: Quote = {
  cite: 'Josh Klahr, Head of Data Warehousing at Snowflake & Harsha Kapre, Director at Snowflake Ventures',
  logo: '/images/partners/snowflake.svg',
  quote: `Omni’s built-in semantic model helps data teams quickly build enterprise data applications. Being able to validate metric definitions allows users to improve the accuracy of models to produce trustworthy results, which is essential for enterprise AI use cases.`,
  cta: '/blog/snowflake-invests-in-omni',
  ctaLabel: 'Learn More',
}

export const QuotePrimaryBid: Quote = {
  cite: 'Jonny Dungay, Analytics and BI Lead at PrimaryBid',
  logo: customerLogos.primaryBid,
  quote: `We wanted to give our customers a truly modern analytics experience without needing to invest significant front-end engineering resources to build it. Of the many embedded analytics products we evaluated, Omni was the only one that would make it possible for us to achieve that goal.`,
  cta: '/blog/case-study-primarybid',
}

export const QuoteMiddleware: Quote = {
  cite: 'Zach Michel, Co-founder',
  logo: customerLogos.middleware,
  quote: `We wanted a tool that had all the features we needed in a single platform and would make everyone's life easier. After testing it, choosing Omni was an easy decision.`,
  cta: '/blog/case-study-middleware',
}

export const QuoteIncidentIo: Quote = {
  cite: 'Jack Colsey, Analytics Manager, incident.io',
  logo: customerLogos.incidentio,
  quote: `The transition from custom SQL in Metabase to a semantic layer in Omni was an opportunity to ‘slow down to speed up’. By migrating to Omni, we were able to consolidate the number of dashboards in our BI tool by 5x.`,
  cta: '/blog/case-study-incident-io',
}

export const QuoteIncidentIo2: Quote = {
  cite: 'Jack Colsey, Analytics Manager, incident.io',
  logo: customerLogos.incidentio,
  quote: `The transition from custom SQL in Metabase to a semantic layer in Omni was an opportunity to “slow down to speed up.” By migrating to Omni, we were able to consolidate the number of dashboards in our BI tool by 5x.`,
  cta: '/blog/case-study-incident-io',
}

export const QuoteIncidentIo3: Quote = {
  cite: 'Jack Colsey, Analytics Manager',
  logo: customerLogos.incidentio,
  quote: `We’ve seen really good adoption across the company. Pretty much everyone is involved in Omni in one way or another.`,
  cta: '/blog/case-study-incident-io',
}

export const QuoteUscreen: Quote = {
  cite: 'Joe Horowitz, VP of Growth & Analytics',
  logo: customerLogos.uscreen,
  quote: `We want to own our business logic, so the dbt <> git workflow works well for us. None of the other vendors seemed to offer that flexibility, but Omni’s bi-directional dbt integration really stood out to us as something that aligned with our philosophy. Beyond technical alignment, Omni seemed like the right partner as a company; it was by far the best sales experience I’ve had. I believe in the future with Omni.`,
  cta: '/blog/case-study-uscreen',
}

export const QuoteUscreen2: Quote = {
  cite: 'Joe Horowitz, VP of Growth & Analytics',
  logo: customerLogos.uscreen,
  quote: `Omni created a pipeline from our Growth & Analytics team directly to our customers, allowing us to deliver massive value quickly. The fact that we had something ready to test in one week, iterated, and fully launched a new offering in a month is insane. This also allows our Product team to focus on what they do best: building value for our customers.`,
  cta: '/blog/case-study-uscreen',
}

export const QuoteUscreen3: Quote = {
  cite: 'Pete Petrin, Senior Analytics Manager',
  logo: customerLogos.uscreen,
  quote: `The velocity and autonomy that Omni gave our team — even just from the POC to the beta — was massive. We were able to overhaul everything so quickly. Now, we’re able to embed analytics into our product without any further developer support.`,
  cta: '/blog/case-study-uscreen',
}

export const QuoteAura: Quote = {
  cite: 'Setareh Lotfi, CTO',
  logo: customerLogos.aura,
  quote: `A lot of our non-technical users are able to upload data that doesn’t live in our data warehouse; it’s fantastic because they don’t need engineering resources to do their work. As someone who leads engineering, Omni’s helped open up my bandwidth because I don’t have to give up as much engineering time and resources to help people do their jobs.`,
}

export const QuoteBuzzfeed: Quote = {
  cite: 'Lizzy Bradford, Senior Director of Analytics',
  logo: customerLogos.buzzfeed,
  quote: `Using Omni has reduced the number of new questions and consolidated the reports our Analytics team needs to build. It’s given us time back while giving our stakeholders more independence to explore what they need.`,
  cta: '/blog/case-study-buzzfeed',
}

export const QuoteFundrise: Quote = {
  cite: 'Luke Ruth, Chief Product Officer',
  logo: customerLogos.fundrise,
  quote: `All of our one-off analyses tie back to the core metrics defined in the shared model: What did this campaign do to Investments? What did this investor interaction do for Growth? Having those core definitions ironed out early makes the migration of all the long-tail definitions much simpler.`,
  cta: '/blog/case-study-fundrise',
}

export const QuoteActiveProspect: Quote = {
  cite: 'Chris Snyder, Director of Data Science',
  logo: customerLogos.activeProspect,
  quote: `Omni’s customization options allowed us to make our embedded analytics match our brand and give our customers a more cohesive experience. We couldn’t do that with Domo.`,
  cta: '/blog/case-study-activeprospect',
}

export const QuoteZapnito: Quote = {
  cite: 'Jon Beer, COO',
  logo: customerLogos.zapnito,
  quote: `It’s quite impressive that we were able to swap platforms and still deliver the same experience while cutting costs, all in 4 weeks.`,
  cta: '/blog/case-study-zapnito',
}
